import { cx } from '@emotion/css';
import type { FC } from 'react';

import { BackgroundColor } from '../../constants';
import { type BreadcrumbProps, Breadcrumb } from './Breadcrumb';
import {
  bgDarkGradientCss,
  bgLightGradientCss,
  breadcrumbCss,
  breadcrumbsListCss,
  breadcrumbsListItemCss,
  breadcrumbsListItemShowMobileCss,
} from './Breadcrumbs.styles';

export type BreadcrumbsProps = {
  backgroundColor: BackgroundColor;
  breadcrumbsItems: BreadcrumbProps[];
  showBgGradient?: boolean;
};

export const Breadcrumbs: FC<BreadcrumbsProps> = ({
  breadcrumbsItems,
  showBgGradient,
  backgroundColor,
}) => {
  if (!breadcrumbsItems.length) return null;

  return (
    <nav aria-label="breadcrumbs" className={breadcrumbCss}>
      <ol
        className={cx(breadcrumbsListCss, {
          [bgLightGradientCss]: showBgGradient && backgroundColor !== BackgroundColor.Black,
          [bgDarkGradientCss]: showBgGradient && backgroundColor === BackgroundColor.Black,
        })}
      >
        {breadcrumbsItems.map((breadcrumb, index) => {
          const isCurrent = index === breadcrumbsItems.length - 1;
          const shouldShowOnMobile = index === breadcrumbsItems.length - 2;

          return (
            <li
              key={breadcrumb.breadcrumbText}
              className={cx(breadcrumbsListItemCss, {
                [breadcrumbsListItemShowMobileCss]: shouldShowOnMobile,
              })}
            >
              <Breadcrumb {...breadcrumb} isCurrent={isCurrent} showBackIcon={shouldShowOnMobile} />
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
